(function (Config, IFrames) {
    
    IFrames.ValidarPago = function (fn) {
        frameEventClient.listen('PAGO-VALIDARPAGO', function (e) {
            fn && fn(e.data);
        });

    }

    IFrames.TYC = function (fn) {
        frameEventClient.listen('TYC', function (e) {
            fn && fn(e.data);
        });
    }
    
    IFrames.Height = function (fn) {
        frameEventClient.listen('DOCUMENT-HEIGHT', function (e) {
            fn && fn(e.data);
        });
    }

})(LN.Config, LN.IFrames);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/iframe.js